import FooterHero from "@/shared/ui/footer-hero/ui/FooterHero.vue";

export default FooterHero;
